import { render, staticRenderFns } from "./information-pc.vue?vue&type=template&id=003064f4&scoped=true&"
import script from "./information-pc.vue?vue&type=script&lang=js&"
export * from "./information-pc.vue?vue&type=script&lang=js&"
import style0 from "./information-pc.vue?vue&type=style&index=0&id=003064f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003064f4",
  null
  
)

export default component.exports